// ###############
// サイドメニュー #
// * title = フォームのタイトル
// * id = htmlのid
// * level: 1=必須, 2=推奨, 3=任意
// * premiseIndexes: 前提となるフォームのindex(同リスト内のindex)
// * storeVal: フォームの入力値が保存されているstoreの変数 ※必須入力の変数のみ指定
// ####################
// 全コマンド共通
const BASE_JUMP_MENU_LIST = [
    { "title": "OS", "id": "os", "level": 1, "storeVal": ["os"] },
    { "title": "コマンド", "id": "cmd", "level": 1, "storeVal": ["cmd"] }
]
// コマンドごと
const SETUP_CMD_JUMP_MENU_LIST = [
    { "title": "コマンド進行形式", "id": "silent", "level": 1, "storeVal": ["silent"] },
    { "title": "アカウント認証用プロキシ", "id": "authProxy", "level": 3, "premiseIndexes": [1], "storeVal": [] },
]
const SHOW_TESTRUN_CMD_JUMP_MENU_LIST = [
    { "title": "プロジェクトインポートフォルダ", "id": "sync", "level": 2, "storeVal": [] },
]
const TESTRUN_CMD_JUMP_MENU_LIST = [
    { "title": "コマンド進行形式", "id": "silent", "level": 1, "storeVal": ["silent"] },
    { "title": "プロジェクトインポート", "id": "doImport", "level": 1, "storeVal": ["syncNotUseExistingTest"] },
    { "title": "プロジェクトインポートフォルダ", "id": "sync", "level": 2, "premiseIndexes": [1], "storeVal": [] },
    { "title": "実行するテストラン名", "id": "testrunName", "level": 1, "storeVal": ["testrunNames"] },
    { "title": "テスト環境", "id": "testEnv", "level": 3, "storeVal": [] },
    { "title": "ブラウザ表示", "id": "background", "level": 1, "storeVal": ["browserBackground"] },
    { "title": "テストランメモ", "id": "testrunMemo", "level": 3, "storeVal": [] },
    { "title": "レポート出力先フォルダ", "id": "reportDir", "level": 3, "storeVal": [] },
    { "title": "テスト実行用プロキシ", "id": "testProxy", "level": 3, "premiseIndexes": [0], "storeVal": [] },
    { "title": "QualityTracker連携", "id": "qt", "level": 3, "storeVal": [] },
    { "title": "QualityTracker連携用プロキシ", "id": "qtProxy", "level": 3, "premiseIndexes": [0, 9], "storeVal": [] },
    { "title": "AnyTest連携", "id": "anytest", "level": 3, "premiseIndexes": [4], "storeVal": [] },
    { "title": "AnyTest連携用プロキシ", "id": "anytestProxy", "level": 3, "premiseIndexes": [0, 11], "storeVal": [] },
]
const SHOW_TESTRUN_WIN_CMD_JUMP_MENU_LIST = [
    { "title": "プロジェクトインポートフォルダ", "id": "sync", "level": 2, "storeVal": [] },
]
const TESTRUN_WIN_CMD_JUMP_MENU_LIST = [
    { "title": "プロジェクトインポート", "id": "doImport", "level": 1, "storeVal": [] },
    { "title": "プロジェクトインポートフォルダ", "id": "sync", "level": 2, "premiseIndexes": [0], "storeVal": [] },
    { "title": "実行するテストラン名", "id": "testrunName", "level": 1, "storeVal": ["testrunNames"] },
    { "title": "Windowsアプリ情報", "id": "winApp", "level": 1, "storeVal": ["winAppName", "winAppPath"] },
    { "title": "テストランメモ", "id": "testrunMemo", "level": 3, "storeVal": [] },
    { "title": "レポート出力先フォルダ", "id": "reportDir", "level": 3, "storeVal": [] },
    { "title": "アカウント認証用プロキシ", "id": "authProxy", "level": 3, "storeVal": [] },
    { "title": "QualityTracker連携", "id": "qt", "level": 3, "storeVal": [] },
    { "title": "QualityTracker連携用プロキシ", "id": "qtProxy", "level": 3, "premiseIndexes": [7], "storeVal": [] },
]

const TESTRUN_MOBILE_CMD_JUMP_MENU_LIST = [
    { "title": "プロジェクトインポート", "id": "doImport", "level": 1, "storeVal": [] },
    { "title": "プロジェクトインポートフォルダ", "id": "sync", "level": 2, "premiseIndexes": [0], "storeVal": [] },
    { "title": "実行するテストラン名", "id": "testrunName", "level": 1, "storeVal": ["testrunNames"] },
    { "title": "モバイルアプリ情報", "id": "mobileApp", "level": 1, "storeVal": ["mobileAppName", "mobileAppPath"] },
    { "title": "テストランメモ", "id": "testrunMemo", "level": 3, "storeVal": [] },
    { "title": "レポート出力先フォルダ", "id": "reportDir", "level": 3, "storeVal": [] },
    { "title": "アカウント認証用プロキシ", "id": "authProxy", "level": 3, "storeVal": [] },
]

const SHOW_TESTRUN_MOBILE_CMD_JUMP_MENU_LIST = [
    { "title": "プロジェクトインポートフォルダ", "id": "sync", "level": 2, "storeVal": [] },
]

// #######################
// cacheに格納する際のキー #
// #######################
const CACHE_KEYS = [
    "scrollTopBeforeReload",
    "os",
    "cmd",
    "anyTestUser",
    "anyTestApiKey",
    "anyTestDeviceId",
    "anyTestRunTime",
    "anyTestProxyAddress",
    "anyTestProxyPort",
    "anyTestProxyAccount",
    "anyTestProxyPassword",
    "authProxyAddress",
    "authProxyPort",
    "authProxyAccount",
    "authProxyPassword",
    "browserChrome",
    "browserEdge",
    "browserFireFox",
    "browserAnyTest",
    "browserBackground",
    "qtWorkspace",
    "qtApiKey",
    "qtTdashTestrun",
    "qtQtProject",
    "qtUsePreviousTestrun",
    "qtStartDate",
    "qtEndDate",
    "qtProxyAddress",
    "qtProxyPort",
    "qtProxyAccount",
    "qtProxyPassword",
    "reportsDir",
    "silent",
    "syncNotUseExistingTest",
    "syncDir",
    "testrunMemo",
    "testrunNames",
    "testProxyAddress",
    "testProxyPort",
    "testProxyAccount",
    "testProxyPassword",
    "testProxyUrl",
    "winAppName",
    "winAppPath",
]

export default {
    // sidebar
    BASE_JUMP_MENU_LIST,
    SETUP_CMD_JUMP_MENU_LIST,
    SHOW_TESTRUN_CMD_JUMP_MENU_LIST,
    TESTRUN_CMD_JUMP_MENU_LIST,
    SHOW_TESTRUN_WIN_CMD_JUMP_MENU_LIST,
    TESTRUN_WIN_CMD_JUMP_MENU_LIST,
    TESTRUN_MOBILE_CMD_JUMP_MENU_LIST,
    SHOW_TESTRUN_MOBILE_CMD_JUMP_MENU_LIST,
    // cache
    CACHE_KEYS,
}
